import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const TagViewModule = new Module({
  id: 'TAG-OPERATION:VIEW:RESULT-TABLE',
  name: 'Tag',
  path: 'tag',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Tags/View'))
  ),
});

export const TagAddModule = new Module({
  id: 'TAG-OPERATION:CREATE:ADD-TAG',
  name: 'TagAdd',
  path: 'tag/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Tags/Form'))
  ),
  actions: {
    add: {
      id: 'TAG-OPERATION:CREATE:ADD-TAG',
      name: 'add-tag',
      label: 'Add Tag'
    }
  }
});

export const TagEditModule = new Module({
  id: 'TAG-OPERATION:EDIT:UPDATE-TAG',
  name: 'TagEdit',
  path: 'tag/edit',
  pathDef: 'tag/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Tags/Form'))
  ),
  actions: {
    edit: {
      id: 'TAG-OPERATION:EDIT:TAG-RESULT-TABLE',
      name: 'edit-tag-result-table',
      label: 'Edit'
    },
    delete: {
      id: 'TAG-OPERATION:DELETE:RESULT-TABLE',
      name: 'delete-tag-result-table',
      label: 'Delete'
    }
  }
});

const TagModules = [TagViewModule, TagEditModule, TagAddModule];

export default new ModuleBundle('Tag', TagModules);
